import React from 'react';
import { format, isAfter } from 'date-fns';
import { ru } from 'date-fns/locale';
import Section from '../../../shared/Section/Section';
import PointsList from '../../../shared/PointsList/PointsList';
import CalendarIcon from '../../../kit/icons/CalendarIcon';
import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Button, Link } from 'gatsby-theme-material-ui';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { preparePrice } from '../../../helpers/lib';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../../helpers/myTarget';
import DiscountLabel from '../../../shared/DiscountLabel/DiscountLabel';

export default function PrecoursePrice({
  title,
  link,
  points,
  bonuses,
  images,
  groups,
  metrics,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const priceData = groups[0]?.price;
  const fullPrice = priceData?.fullPrice;
  const discountPrice = priceData?.discountPrice;
  const discountValue =
    5 * Math.round((100 - (discountPrice / fullPrice) * 100) / 5);
  const startDate = groups && groups[0]?.startDate;
  const formattedDate =
    startDate && format(new Date(startDate), 'dd MMMM', { locale: ru });
  const formattedDiscountDate =
    priceData?.discountEndDate &&
    format(
      new Date(priceData.discountEndDate),
      `${isSm ? 'dd.MM' : 'dd.MM.yyyy'}`,
      { locale: ru },
    );
  const isDiscount = discountPrice && discountValue > 0;
  const price = isDiscount ? discountPrice : fullPrice;
  const imgStyle = isSm ? { width: 60, height: 44 } : { width: 90, height: 72 };
  const sendMetrics = () => {
    metrics?.ym && sendYandexMetrikaEvent(metrics.ym);
    metrics?.mt && sendMyTargetEvent(metrics.mt);
  };
  const button = (
    <Link href={link}>
      <Button
        variant="kitPrimary"
        size="large"
        sx={{ mt: 4 }}
        onClick={sendMetrics}
      >
        Купить курс
      </Button>
    </Link>
  );
  return (
    <Section theme="light" bg={'prepare-interview'}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography variant="desktopH2" color={'kit.text.main'}>
            {title}
          </Typography>
          <Box mt={{ xs: 3, lg: 4 }}>
            <PointsList
              list={points}
              textProps={{ fontSize: { xs: 14, md: 16 } }}
            />
          </Box>
          <Box sx={{ mt: 4, display: 'flex', gap: 1.5 }}>
            {startDate ? (
              <>
                <CalendarIcon />
                <Typography variant="desktopP1" color={'kit.text.main'}>
                  {`старт: ${formattedDate}`}
                </Typography>
              </>
            ) : (
              <Skeleton width={100} />
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mt: { xs: 1.5, lg: 3 },
            }}
          >
            <Typography
              component={'p'}
              variant="desktopH2"
              color={'kit.text.main'}
            >
              {price ? `${preparePrice(price)} ₽` : <Skeleton width={120} />}
            </Typography>
            {isDiscount && (
              <DiscountLabel
                discountValue={discountValue}
                fullPrice={fullPrice}
                formattedDiscountDate={formattedDiscountDate}
                isMobile={isSm}
              />
            )}
          </Box>
          {!isSm && button}
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={1}
            sx={{
              mt: { xs: 2, lg: 0 },
              p: { xs: '12px 16px', lg: '24px 21px 32px' },
              width: { xs: '100%', md: 497 },
              boxShadow: '0px 32px 58px 0px rgba(174, 168, 207, 0.18)',
            }}
          >
            <Typography variant="desktopH4" color="kit.text.h">
              Бонусы:
            </Typography>
            <Box
              sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              {bonuses &&
                bonuses.map((bonus) => (
                  <Box
                    key={bonus.point}
                    sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
                  >
                    <Box sx={{ width: imgStyle.width }}>
                      <GatsbyImage
                        image={getImage(images[`payment/${bonus.image}`])}
                        alt="img"
                        style={imgStyle}
                      />
                    </Box>
                    <Typography variant="desktopP2">{bonus.point}</Typography>
                  </Box>
                ))}
            </Box>
          </Paper>
          <Typography
            variant="desktopP3Helper"
            sx={{
              mt: { xs: 1.5, lg: 4 },
              fontSize: { xs: 11, md: 12 },
              letterSpacing: '-0.01em',
            }}
          >
            *Сделаем скидку при поступлении в буткемп в течение недели после
            окончания курса
          </Typography>
          {isSm && button}
        </Grid>
      </Grid>
    </Section>
  );
}
